var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcModal',{attrs:{"size":"full"},on:{"close":_vm.onClose}},[_c('div',{staticClass:"message-source"},[_c('h2',[_vm._v(_vm._s(_vm.t('mail', 'Message source')))]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.rawMessage))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }